// Plans and services, roles, website editor, currencies and fixes (round 14).
export default {
  // Currencies
  "Omani Rial": "ريال عماني",
  "Kuwaiti Dinar": "دينار كويتي",
  "Bahraini Dinar": "دينار بحريني",
  "Jordanian Dinar": "دينار أردني",
  "Iraqi Dinar": "دينار عراقي",
  "Lebanese Pound": "ليرة لبنانية",
  "Yemeni Rial": "ريال يمني",
  "Tunisian Dinar": "دينار تونسي",
  "Algerian Dinar": "دينار جزائري",
  "Libyan Dinar": "دينار ليبي",
  "Pakistani Rupee": "روبية باكستانية",
  "Bangladeshi Taka": "تاكا بنغلاديشي",
  "Philippine Peso": "بيزو فلبيني",

  // Hero and landing page
  "Your website, orders and customers.": "موقعك وطلباتك وعملاءك.",
  "Launch a website for your restaurant, shop or salon in minutes. Take orders and bookings, keep your customers coming back, deliver anywhere in the Gulf and get paid - in Arabic and English.": "أطلق موقعًا لمطعمك أو متجرك أو صالونك في دقائق. استقبل الطلبات والحجوزات، واحتفظ بعملائك، ووصّل لأي مكان في الخليج واستلم أموالك - بالعربية والإنجليزية.",
  "Run one service, or combine the menu, an online store and bookings in the same store - one dashboard for all of it.": "شغّل خدمة واحدة، أو اجمع المنيو والمتجر الإلكتروني والحجوزات في متجر واحد - ولوحة تحكم واحدة لكل ذلك.",
  "All the apps your business needs": "كل التطبيقات التي يحتاجها نشاطك",
  "Every store comes with these tools, ready to switch on from your dashboard.": "كل متجر يأتي مع هذه الأدوات، جاهزة للتفعيل من لوحة التحكم.",
  "Built for businesses across the Gulf": "مصمَّم للأنشطة في كل دول الخليج",
  "Local currencies, delivery to every city and Arabic first - wherever you sell.": "عملات محلية، وتوصيل لكل مدينة، والعربية أولًا - أينما كنت تبيع.",
  "POS & cashier": "نقطة البيع والكاشير",
  "Ring up walk-in sales, take cash or card, print the bill and see every order in one list.": "سجّل مبيعات الزبائن الحاضرين، واستلم نقدًا أو بالبطاقة، واطبع الفاتورة، وشاهد كل الطلبات في قائمة واحدة.",
  "Kitchen screen": "شاشة المطبخ",
  "New orders appear on the kitchen screen with a sound, from the website, the tables and the POS.": "تظهر الطلبات الجديدة على شاشة المطبخ مع صوت تنبيه، من الموقع والطاولات ونقطة البيع.",
  "Customers earn points on every order and swap them for rewards. Included in every plan.": "يجمع العملاء نقاطًا مع كل طلب ويستبدلونها بمكافآت. متاح في كل الباقات.",
  "Add-on": "إضافة",
  "Staff & roles": "الموظفون والصلاحيات",
  "Cashier, kitchen, driver, accountant or your own roles, each seeing only their pages.": "كاشير، مطبخ، سائق، محاسب أو أدوار تحددها أنت، وكل شخص يرى صفحاته فقط.",
  "Inventory & stock": "المخزون",
  "Stock that updates with every sale, ingredient recipes and low-stock alerts.": "مخزون يتحدث مع كل عملية بيع، ووصفات للمكونات، وتنبيهات عند انخفاض الكمية.",
  "Delivery & shipping": "التوصيل والشحن",
  "A price for every city in the Gulf, free delivery from an amount you choose, or pickup.": "سعر لكل مدينة في الخليج، وتوصيل مجاني من مبلغ تحدده، أو استلام من المحل.",
  "Reports & accounting": "التقارير والمحاسبة",
  "Sales by day, best sellers, payment methods and staff performance, ready to export.": "المبيعات اليومية، والأكثر مبيعًا، وطرق الدفع، وأداء الموظفين، جاهزة للتصدير.",
  "QR codes & tables": "رموز QR والطاولات",
  "Printable QR codes for every table, flyer and package, linked to your own website.": "رموز QR قابلة للطباعة لكل طاولة ومنشور وعبوة، مرتبطة بموقعك.",
  "Online payments": "الدفع الإلكتروني",
  "Customer accounts": "حسابات العملاء",
  "Customers follow their orders, bookings and points from their own account.": "يتابع العملاء طلباتهم وحجوزاتهم ونقاطهم من حسابهم الخاص.",
  "Pick a template, then change texts, colors and photos and see your website live.": "اختر قالبًا، ثم غيّر النصوص والألوان والصور وشاهد موقعك مباشرة.",
  "New order alerts": "تنبيهات الطلبات الجديدة",
  "A sound and a message on your dashboard the moment an order or booking comes in.": "صوت ورسالة على لوحة التحكم لحظة وصول طلب أو حجز.",
  "Printed bills": "فواتير مطبوعة",
  "Print a clear receipt from the POS or any order, with your logo and your currency.": "اطبع إيصالًا واضحًا من نقطة البيع أو من أي طلب، بشعارك وعملتك.",
  "Pick your plan and your services, then choose your website name. No card needed.": "اختر باقتك وخدماتك، ثم اسم موقعك. بدون بطاقة.",
  "business types in one platform": "أنواع أعمال في منصة واحدة",
  "Gulf countries": "دول خليجية",
  "apps included": "تطبيقًا مشمولًا",
  "Made for the Gulf": "مصمَّم للخليج",
  "Can one store sell products and take bookings too?": "هل يمكن لمتجر واحد أن يبيع المنتجات ويستقبل الحجوزات أيضًا؟",
  "Yes. Depending on your plan you can run the menu, an online store and bookings together in the same store, managed from one dashboard.": "نعم. حسب باقتك يمكنك تشغيل المنيو والمتجر الإلكتروني والحجوزات معًا في المتجر نفسه، وإدارتها من لوحة تحكم واحدة.",
  "Yes. Add the main cities of any Gulf country in one click (Oman, Saudi Arabia, the UAE, Qatar, Kuwait or Bahrain), or type your own areas, and give each one its own price and free-delivery amount.": "نعم. أضف المدن الرئيسية لأي دولة خليجية بضغطة واحدة (عُمان أو السعودية أو الإمارات أو قطر أو الكويت أو البحرين)، أو اكتب مناطقك بنفسك، وحدّد لكل منها سعرها ومبلغ التوصيل المجاني.",
  "Dubai": "دبي",
  "Doha": "الدوحة",
  "See all apps": "شاهد كل التطبيقات",
  "All apps": "كل التطبيقات",
  "Websites, orders, customers and bookings for businesses across the Gulf - in Arabic and English.": "مواقع وطلبات وعملاء وحجوزات للأنشطة في كل دول الخليج - بالعربية والإنجليزية.",

  // Plans and pricing
  "Services: {list}.": "الخدمات: {list}.",
  "WhatsApp marketing campaigns can be added to any plan for an extra monthly fee.": "يمكن إضافة حملات تسويق واتساب إلى أي باقة برسوم شهرية إضافية.",
  "Included": "مشمول",
  "Paid add-on": "إضافة مدفوعة",
  "Compare plans": "قارن بين الباقات",
  "Monthly price": "السعر الشهري",
  "Also included": "يشمل أيضًا",
  "All services in one store": "كل الخدمات في متجر واحد",
  "Choose one service": "اختر خدمة واحدة",
  "Choose {n} services in one store": "اختر {n} خدمات في متجر واحد",
  "Unlimited users": "مستخدمون بلا حدود",
  "1 user (you)": "مستخدم واحد (أنت)",
  "Up to {n} users": "حتى {n} مستخدمين",
  "Starter": "الأساسية",
  "Growth": "النمو",
  "Your own subdomain + basic theme": "رابط خاص (Subdomain) + ثيم أساسي",
  "Simple sales reports": "تقارير مبيعات مبسطة",
  "Email and WhatsApp support": "دعم عبر البريد والواتساب",
  "Your own subdomain + full design control": "رابط خاص + تخصيص كامل للتصميم",
  "Accounting and sales reports": "نظام محاسبي + تقارير المبيعات",
  "Live WhatsApp support": "دعم مباشر عبر الواتساب",
  "Your own domain or subdomain": "رابط خاص أو دومين خاص",
  "Full finance and staff reports": "إدارة مالية كاملة + تقارير الموظفين",
  "Dedicated 24/7 account manager": "مدير حساب مخصص 24/7",

  // Sign-up
  "This plan includes up to {n} services. Pick a bigger plan for more.": "هذه الباقة تشمل حتى {n} خدمات. اختر باقة أكبر للمزيد.",
  "Choose a plan": "اختر باقة",
  "Choose at least one service": "اختر خدمة واحدة على الأقل",
  "Choose your plan": "اختر باقتك",
  "Every plan starts with a free trial. You can change it any time.": "كل باقة تبدأ بفترة تجربة مجانية، ويمكنك تغييرها في أي وقت.",
  "What will your store offer?": "ماذا سيقدّم متجرك؟",
  "Your plan includes one service.": "باقتك تشمل خدمة واحدة.",
  "Pick up to {n}. They all live in the same store and the same admin.": "اختر حتى {n}. كلها في المتجر نفسه ولوحة التحكم نفسها.",
  "Your plan includes every service. They all live in the same store and the same admin.": "باقتك تشمل كل الخدمات، وكلها في المتجر نفسه ولوحة التحكم نفسها.",
  "Home page": "الصفحة الرئيسية",
  "What do customers book?": "ماذا يحجز العملاء؟",
  "The first one you picked opens as your home page. You can change this later in Settings.": "أول خدمة اخترتها تظهر كصفحة رئيسية، ويمكنك تغيير ذلك لاحقًا من الإعدادات.",
  "Store name": "اسم المتجر",
  "Contact phone (optional)": "هاتف التواصل (اختياري)",
  "Shown to your customers and on your receipts. You can change them in Settings.": "يظهر لعملائك وعلى الإيصالات، ويمكنك تغييره من الإعدادات.",
  "Choose one of the plans": "اختر إحدى الباقات",
  "Your plan includes one service. Choose one.": "باقتك تشمل خدمة واحدة. اختر واحدة.",
  "Your plan does not include that many services.": "باقتك لا تشمل هذا العدد من الخدمات.",

  // Services
  "Menu & pre-orders": "المنيو والطلب المسبق",
  "A QR menu for restaurants and cafés: dine-in, pickup and delivery orders, kitchen screen and tables.": "منيو QR للمطاعم والمقاهي: طلبات داخل المحل والاستلام والتوصيل، وشاشة المطبخ والطاولات.",
  "Sell products with photos, options, stock and delivery prices per city.": "بِع منتجاتك بالصور والخيارات والمخزون وأسعار التوصيل لكل مدينة.",
  "Bookings & appointments": "الحجوزات والمواعيد",
  "Salons, clinics, offices and rooms: customers book a time online.": "صالونات وعيادات ومكاتب وغرف: يحجز العملاء موعدهم أونلاين.",
  "Your services": "خدماتك",
  "Your plan includes up to {n} services.": "باقتك تشمل حتى {n} خدمات.",
  "Your plan includes up to {n} services, all in the same store.": "باقتك تشمل حتى {n} خدمات، كلها في المتجر نفسه.",
  "Your plan includes every service, all in the same store.": "باقتك تشمل كل الخدمات، كلها في المتجر نفسه.",
  "Opens first on your website": "تظهر أولًا في موقعك",
  "Open this first on my website": "اجعلها أول ما يظهر في موقعي",
  "Need more services? Change your plan": "تحتاج خدمات أكثر؟ غيّر باقتك",
  "Choose a plan in Billing to add more services.": "اختر باقة من صفحة الفوترة لإضافة المزيد من الخدمات.",
  "Save services": "حفظ الخدمات",
  "Services updated": "تم تحديث الخدمات",
  "Could not update your services": "تعذّر تحديث خدماتك",
  "Keep at least one service": "أبقِ خدمة واحدة على الأقل",
  "Your plan includes one service. Upgrade your plan to add more.": "باقتك تشمل خدمة واحدة. رقِّ باقتك لإضافة المزيد.",
  "Your plan does not include that many services. Upgrade your plan to add more.": "باقتك لا تشمل هذا العدد من الخدمات. رقِّ باقتك لإضافة المزيد.",
  "Store sections": "أقسام المتجر",
  "Shop": "المتجر",
  "Book an appointment": "احجز موعدًا",
  "What this business offers on its website and admin. The first one opens as its home page.": "ما يقدمه هذا النشاط في موقعه ولوحة تحكمه. الأولى تظهر كصفحة رئيسية.",
  "Choose one of your categories": "اختر أحد تصنيفاتك",

  // Platform plans
  "Choose one": "خدمة واحدة",
  "Choose two": "خدمتان",
  "No limit": "بلا حد",
  "What the plan includes (one per line)": "ما تشمله الباقة (ميزة في كل سطر)",
  "e.g. Live WhatsApp support": "مثال: دعم مباشر عبر الواتساب",
  "Plan updated": "تم تحديث الباقة",
  "Monthly prices businesses can subscribe to, with how many services and users each includes. You can still set a custom price for one business from its page.": "الأسعار الشهرية التي يمكن للأنشطة الاشتراك بها، مع عدد الخدمات والمستخدمين في كل باقة. ويمكنك تحديد سعر خاص لنشاط معيّن من صفحته.",
  "Edit plan": "تعديل الباقة",

  // Employees and roles
  "Give this role a name": "أعطِ هذا الدور اسمًا",
  "Choose at least one page this role can open": "اختر صفحة واحدة على الأقل يمكن لهذا الدور فتحها",
  "{used} of {max} users on your plan (you included)": "{used} من {max} مستخدمين في باقتك (بما فيهم أنت)",
  "Upgrade": "ترقية",
  "Other roles": "أدوار أخرى",
  "More roles": "أدوار إضافية",
  "Other (choose a name and pages)": "أخرى (حدّد الاسم والصفحات)",
  "Access": "الصلاحيات",
  "Role name *": "اسم الدور *",
  "e.g. Delivery driver": "مثال: سائق توصيل",
  "Pages this role can open *": "الصفحات التي يمكن لهذا الدور فتحها *",
  "Settings, website design and billing stay with the owner and admins.": "الإعدادات وتصميم الموقع والفوترة تبقى للمالك والمدراء فقط.",
  "Admins can open everything, including settings.": "المدير يمكنه فتح كل شيء، بما في ذلك الإعدادات.",
  "Can open:": "يمكنه فتح:",
  "Monthly salary": "الراتب الشهري",
  "Delivery driver": "سائق توصيل",
  "Accountant": "محاسب",
  "Stock keeper": "أمين المخزن",
  "Receptionist": "موظف استقبال",
  "Marketing": "التسويق",
  "Your plan has no room for more users. Upgrade your plan to add more staff.": "لا تتسع باقتك لمستخدمين إضافيين. رقِّ باقتك لإضافة موظفين.",

  // Shipping
  "Add {country} cities": "أضف مدن {country}",

  // Orders, sounds and bills
  "New order sound is on": "صوت الطلبات الجديدة مفعّل",
  "New order sound is off": "صوت الطلبات الجديدة متوقف",
  "Turn off new order sound": "إيقاف صوت الطلبات الجديدة",
  "Turn on new order sound": "تشغيل صوت الطلبات الجديدة",
  "New table reservation": "حجز طاولة جديد",
  "New booking": "حجز جديد",
  "Order {order_code}: {status}": "الطلب {order_code}: {status}",
  "Payment recorded: {totalPaid}": "تم تسجيل الدفع: {totalPaid}",
  "Print last bill": "طباعة آخر فاتورة",
  "Bill": "فاتورة",
  "No items": "لا توجد عناصر",
  "Discount": "الخصم",
  "Bill preview": "معاينة الفاتورة",
  "Use a percentage from 0 to 100": "أدخل نسبة من 0 إلى 100",

  // Product options
  "Customers can choose": "يمكن للعميل اختيار",
  "Only one option": "خيار واحد فقط",
  "Several options": "عدة خيارات",
  "For sizes or types, like Small / Medium / Large.": "للمقاسات أو الأنواع، مثل صغير / وسط / كبير.",
  "For extras, like cheese + sauce. Their prices add up.": "للإضافات، مثل جبن + صوص. تُجمع أسعارها.",
  "Choose any options you like, or skip them": "اختر ما تشاء من الخيارات، أو تخطَّها",
  "choose any": "اختر ما تشاء",
  "Choose only one option for this product": "اختر خيارًا واحدًا فقط لهذا المنتج",

  // Website editor
  "Edit live": "تعديل مباشر",
  "Edit your website live": "عدّل موقعك مباشرة",
  "See your real website, click any text to change it, hide anything you don't want, and pick your colors and layout. Publish when you're happy.": "شاهد موقعك الحقيقي، واضغط على أي نص لتغييره، وأخفِ ما لا تريده، واختر ألوانك وتصميمك. ثم انشر عندما تكون راضيًا.",
  "Open the editor": "افتح المحرر",
  "Could not load your website": "تعذّر تحميل موقعك",
  "Your website is updated": "تم تحديث موقعك",
  "Discard all changes you have not published?": "تجاهل كل التغييرات التي لم تنشرها؟",
  "Leave without publishing your changes?": "المغادرة بدون نشر تغييراتك؟",
  "Website editor": "محرر الموقع",
  "Mode": "الوضع",
  "Page": "الصفحة",
  "Screen size": "حجم الشاشة",
  "Computer": "كمبيوتر",
  "Tablet": "تابلت",
  "Browse": "تصفح",
  "Discard": "تجاهل",
  "Publishing...": "جارٍ النشر...",
  "Publish": "نشر",
  "Website preview": "معاينة الموقع",
  "Open the editor from your store’s own address to edit it live.": "افتح المحرر من رابط متجرك لتعديله مباشرة.",
  "Open my store’s editor": "افتح محرر متجري",
  "Click any text or item on your website: change its words, or hide it. Use \"Select bigger area\" to hide a whole card or section.": "اضغط على أي نص أو عنصر في موقعك: غيّر كلماته أو أخفِه. استخدم «تحديد منطقة أكبر» لإخفاء بطاقة أو قسم كامل.",
  "Browse mode: click around your website like a customer. Switch back to Edit to change things.": "وضع التصفح: تنقّل في موقعك كأنك عميل. عُد إلى وضع التعديل لتغيير الأشياء.",
  "Menu layout": "تصميم المنيو",
  "Store layout": "تصميم المتجر",
  "Booking page layout": "تصميم صفحة الحجز",
  "Page background": "خلفية الصفحة",
  "Text color": "لون النص",
  "Use the template color": "استخدم لون القالب",
  "Changed texts": "النصوص المعدّلة",
  "None yet. Click a text on your website to change it.": "لا شيء بعد. اضغط على نص في موقعك لتغييره.",
  "Undo": "تراجع",
  "Hidden items": "العناصر المخفية",
  "None. Click an item and choose Hide to remove it from your website.": "لا شيء. اضغط على عنصر واختر «إخفاء» لإزالته من موقعك.",
  "Show": "إظهار",
  "Product names, prices and photos are changed on the products page.": "أسماء المنتجات وأسعارها وصورها تُعدَّل من صفحة المنتجات.",
  "Customer account": "حساب العميل",
  "Edit item": "تعديل العنصر",
  "Text": "النص",
  "hidden": "مخفي",
  "Apply text": "تطبيق النص",
  "Show again": "إظهار مجددًا",
  "Select bigger area": "تحديد منطقة أكبر",

  // Menu template names
  "Classic": "كلاسيكي",
  "Modern": "عصري",
  "Elegant": "أنيق",
  "Minimal": "بسيط",
  "Luxury": "فاخر",
  "Healthy": "صحي",
  "Casual": "غير رسمي",
  "Café": "مقهى",
  "Steakhouse": "مطعم ستيك",
  "Sushi": "سوشي",
  "Bar": "بار",
  "Choose your room": "اختر غرفتك",
  "Check-in on Thursday": "الوصول يوم الخميس",
  "Deluxe room": "غرفة ديلوكس",
  "Family suite": "جناح عائلي",
  "Sea view room": "غرفة بإطلالة بحرية",
  "Free and booked hours today": "الساعات المتاحة والمحجوزة اليوم",
  "Meeting room A": "قاعة الاجتماعات أ",
  "Hot desk": "مكتب مشترك",
  "Private office": "مكتب خاص",
  "Your points": "نقاطك",
  "250 more points for a free coffee": "250 نقطة أخرى وتحصل على قهوة مجانية",
  "Weekend offer: 20% off all desserts. Show this message at the counter.": "عرض نهاية الأسبوع: خصم 20% على جميع الحلويات. اعرض هذه الرسالة عند الكاشير.",
  "For hotels & guest houses": "للفنادق والنُزُل",
  "Take room bookings without the middleman": "استقبل حجوزات الغرف بدون وسيط",
  "List your rooms with photos and prices. Guests pick a free time and book directly on your own website - no commission on any booking.": "اعرض غرفك بالصور والأسعار. يختار الضيف الوقت المتاح ويحجز مباشرة من موقعك - بدون أي عمولة على الحجوزات.",
  "Rooms with photos and prices": "غرف بالصور والأسعار",
  "Booking confirmations by email": "تأكيد الحجز بالبريد الإلكتروني",
  "Pay at the hotel, by bank transfer or card": "الدفع في الفندق أو بالتحويل البنكي أو بالبطاقة",
  "For offices & coworking spaces": "للمكاتب ومساحات العمل المشتركة",
  "Rent desks and meeting rooms by the hour": "أجّر المكاتب وقاعات الاجتماعات بالساعة",
  "List your desks, meeting rooms and private offices. Members book the free hours themselves, and a taken hour cannot be booked twice.": "اعرض مكاتبك وقاعات الاجتماعات والمكاتب الخاصة. يحجز العملاء الساعات المتاحة بأنفسهم، والساعة المحجوزة لا يمكن حجزها مرتين.",
  "Desks, meeting rooms and offices": "مكاتب وقاعات اجتماعات ومكاتب خاصة",
  "Hourly time slots": "حجز بالساعة",
  "Only free times can be booked": "لا يمكن حجز إلا الأوقات المتاحة",
  "For every business": "لكل الأنشطة",
  "Bring your customers back again and again": "اجعل عملاءك يعودون مرة بعد مرة",
  "Customers collect points on every order and swap them for rewards. Send offers on WhatsApp to the customers who asked for them.": "يجمع العملاء النقاط مع كل طلب ويستبدلونها بمكافآت. وأرسل العروض عبر واتساب للعملاء الذين وافقوا على استلامها.",
  "Loyalty points in every plan": "نقاط الولاء في كل الباقات",
  "Rewards your customers can claim": "مكافآت يستبدلها عملاؤك",
  "Customer accounts with order history": "حسابات للعملاء مع سجل الطلبات",
  "WhatsApp offers from your own number": "عروض واتساب من رقمك الخاص",
};
